(() => {
  if (window.WNLocalization) return;
  window.WNLocalization = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-localization-select]');
    const form = select?.form;
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });
})();
